export default __webpack_public_path__ + "static/media/headshot-adri-mukherjee.25e6d6ef.jpg";